// Сборка значения `X-Client-Version` при старте (T-041). Хранит его `shared/api`.

import { Capacitor } from '@capacitor/core';

import { type ClientPlatform, formatClientVersion, setClientVersion } from '@/shared/api';
import { isDesktopShell } from '@/shared/lib/shell';

import { shellVersion } from './updater';

function clientPlatform(): ClientPlatform {
  if (isDesktopShell()) return 'windows';
  // Других нативных платформ у продукта нет; появится iOS — сервер отбросит незнакомое
  // значение молча, и его надо будет добавить в `ClientPlatform` на обеих сторонах.
  return Capacitor.isNativePlatform() ? 'android' : 'browser';
}

/**
 * Вычислить версию и положить её в память httpClient.
 *
 * Версия веб-слоя — константа сборки: бандл знает сам, из какой версии собран, и не
 * зависит от того, как его доставили (в APK или по воздуху).
 */
export async function initClientVersion(): Promise<void> {
  const platform = clientPlatform();
  const shell = platform === 'browser' ? null : await shellVersion();
  setClientVersion(formatClientVersion(platform, shell, __APP_VERSION__));
}
